/* ------------------------
 Additions to Shopify lib
------------------------ */
Shopify.handleize = function (str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

/* ------------------------
Custom Theme JS
------------------------ */
window.theme = window.theme || {};

theme.cacheSelectors = function () {
  var $header = $('#site-header');
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    $header: $header,
    headerHeight: $header.outerHeight(),

    // Add to cart - Ajax
    $cartCount: $('.cart-count'),
    $addToCartBtn: $('[data-add-to-cart]'),
    // $addToCartBtn: $('#AddToCart'), 
    // $addToCartBtn: $('form[action^="/cart/add"] :submit'),
    $cartFlyout: $('#cart-flyout'),
    $cartTrigger: $('.menu__cart'),
    $searchTrigger: $('.menu__search'),
    $searchForm: $('#header-search'),
    $quiz: $('#quiz')
  }
};

theme.init = function(){
  theme.cacheSelectors();
  theme.browserDetect();
  theme.mobileDetect();
  theme.cartPage();
  theme.fancy();
  theme.visibility();
  // theme.quickshop();
  // theme.quickshopListener();
  // theme.mobileMenu();
  // theme.homepage();
  // theme.responsiveIframes();
  // theme.searchInit();
  theme.faq();
  theme.tenstep();
  theme.hpTenStep();
  theme.collection();
  // theme.jqueryUI();
  theme.mailChimp();
  theme.customerTemplates.init();
  // theme.enableAjax();
  // theme.addToCart();
  theme.filterBlog();
  // theme.cache.$w.load(function(){
    // theme.matchHeight();
  // });

  // if ( theme.cache.$w.width() > 990 ) {
  //  theme.initCartFlyout();
  // }

  // theme.initCartFlyout();

  if (theme.cache.$body.hasClass('page-skin-quiz')) {
    theme.skinQuiz();
  }
  if (theme.cache.$body.hasClass('collection-skin-quiz')) {
    theme.skinQuizResults();
  }
};

// theme.quickshop = function() {
//  $('.quickshop-trigger').on('click', function(event) {
//    event.preventDefault();
//    var dest = $(this).data('url') + '?view=quick-shop';
//    $.fancybox({
//      href: dest,
//      type: 'iframe',
//      padding: 0,
//      autoSize: false,
//      maxWidth: 800,
//      height: 'auto'
//    });
//  });
// };

// theme.quickshopListener = function() {
//   var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
//   var eventer = window[eventMethod];
//   var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
//   eventer(messageEvent, function(e) {

//     try {
//       jsonobject =  JSON.parse(e.data);
//     } catch (e) {
//       return false;
//     }

//     if(jsonobject.action && jsonobject.action == 'updateCart') {
//      // theme.buildCartFlyout(false);
//      $.getJSON('/cart.js', function(cart) {
//         $('#flyout-count').text(cart.item_count);
//       });
//     }

//   });
// };

theme.fancy = function(){
  $('.fancy-trigger').click(function(e){
    e.preventDefault();
    var dest = $(this).data('trigger');
    $.fancybox({
      href: '#'+dest,
      padding: 0,
      autoSize: false,
      maxWidth: 700,
      height: 'auto'
    });
  });
};

// theme.responsiveIframes = function(){
//   $('.video-wrapper').fitVids();
// }

theme.visibility = function(){
  $('.visibility-trigger').click(function(e){
    e.preventDefault();
    var dest = $(this).data('trigger');
    $('#'+dest).toggleClass('hidden');
  });
};

theme.browserDetect = function(){
  var browser_warning = null;
  
    browser_warning = 'Our apologies. Sokogalm does not support your browser. Please download a more recent browser version.';
  

  // ie version less than 9
  if ($('html').is('.lt-ie7') || $('html').is('.lt-ie8') || $('html').is('.lt-ie9')) {
    theme.cache.$body.addClass('is-old-ie').prepend('<div id="browser-msg"><div><p>'+browser_warning+'</p><br>Minimum required configuration:</br><span>Windows:</span><ul><li>- Internet Explorer 9.0 or later</li></ul><span>Mac:</span><ul><li>- Safari 4 or later</li><li>- Mozilla Firefox 10.0 or later</li><li>- Google Chrome 12.0 or later</li><ul><span>Mobile</span><ul><li>- iOS 8 or later</li><li>- Android 4.3 or later</li></ul></div></div>').hide().fadeIn();
  }
};

theme.mobileDetect = function(){
  var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
  };

  if(isMobile.any()){
    theme.cache.$body.addClass('is-mobile-device');
  } else {
    theme.cache.$body.addClass('not-mobile-device');
  }

};



// theme.fitVids = function(){
//   var $hhb = $('#home-hero-block'),
//       $ssb = $('.ss-block-media'),
//       $rte = $('.rte');

//   if($hhb.length > 0){
//     $hhb.fitVids();
//   } else if ($ssb.length > 0) {
//     $ssb.fitVids();
//   } else if ($rte.length > 0){
//     $rte.fitVids();
//   } 
// };

// theme.mobileMenu = function() {
//   var $menuBtn = $('#mobile-menu__btn'),
//       $menu = $('#main-nav'),
//       $subMenuBtn = $('.mobile-dropdown-arrow'),
//       $navTools = $('#nav-tools');

//   $menuBtn.on('click', function(){
//     $menuBtn.toggleClass('open');
//     $navTools.toggleClass('open');
//     $menu.stop().slideToggle();

//     if (theme.cache.$searchTrigger.hasClass('active')) {
//       theme.cache.$searchTrigger.removeClass('active');
//       theme.cache.$searchForm.removeClass('show').hide();
//     }
//   });

//   $subMenuBtn.click(function(){
//     var $me = $(this);

//     $me.parents('.menu-parent').toggleClass('open');
//     $me.siblings('.menu-dropdown').stop().slideToggle();
//   });

//   setMenuHeight();
//   theme.cache.$w.on('resize', function(){
//     setMenuHeight();
//   });

//   function setMenuHeight() {
//     $menu.css({ maxHeight: theme.cache.$w.height() - theme.cache.$header.outerHeight() });
//   }
// }

// theme.homepage = function(){
//  var $win = $(window),
//      $slider = $('#hp-promo-slider'),
//      $productSlider = $('#product-slider'),
//      $horizContent = $('.horiz-scroll-content'),
//      $klogFeed = $('#klog-feed'),
//      $breakpoint = 768;

//  $productSlider.slick({
//    'arrows': true,
//    "dots": false
//  }).on('afterChange', function(slick, current){
//    $productSlider.prev('.number').find('.current').text(current.currentSlide+1);
//  });

//  if (theme.cache.$w.width() > 767) {
//    $klogFeed
//      .stick_in_parent({
//        offset_top: theme.cache.headerHeight
//      })
//      .on('sticky_kit:stick', function(e) {
//        $klogFeed.parent().css({
//          'float': 'right'
//        });
//      })
//      .on('sticky_kit:bottom', function(e) {
//        $klogFeed.parent().css({
//          'position': 'static',
//          'width': '28%'
//        });
//      })
//  }

//  function hpResize(){
//     console.log($win.width());
//    if( $win.width() < $breakpoint ) {
//      if(!$slider.hasClass('slick-initialized')){
//        $slider.slick({
//          'arrows': false,
//          'dots': true
//        });
//      }
//      if(!$horizContent.hasClass('horiz-scroll')){
//        $horizContent.each(function(){
//          var $me = $(this),
//              $items = $me.find('.horiz-scroll-item'),
//              $numItems = $items.length,
//              $itemWidth = $items.first().outerWidth(true);

//          $me.addClass('horiz-scroll').css({'width': ($itemWidth * $numItems) + 15 });
//        });
//      }
//    } else
//    if( $win.width() >= $breakpoint ) {
//      if($slider.hasClass('slick-initialized')){
//        $slider.slick('unslick');
//      }
//      if($horizContent.hasClass('horiz-scroll')){
//        $horizContent.removeClass('horiz-scroll').css({'width': 'auto'});
//      }
//    }
//  }

//  hpResize();
//  $win.on('resize', hpResize);
// }

theme.mailChimp = function(){
  ajaxMailChimpForm($("#mc-embedded-subscribe-form"), $("#mce-responses"));
  ajaxMailChimpForm($("#mc-embedded-subscribe-form-2"), $("#mce-responses-2"));

  // Turn the given MailChimp form into an ajax version of it.
  // If resultElement is given, the subscribe result is set as html to
  // that element.
  function ajaxMailChimpForm($form, $resultElement){
    // Hijack the submission. We'll submit the form manually.
    $form.submit(function(e) {
      e.preventDefault();
      if (!isValidEmail($form)) {
        var error =  "A valid email address must be provided.";
        $resultElement.html(error);
      } else {
        $resultElement.html("Subscribing...");
        submitSubscribeForm($form, $resultElement);
      }
    });
  }

  // Validate the email address in the form
  function isValidEmail($form) {
    // If email is empty, show error message.
    // contains just one @
    var email = $form.find("input[type='email']").val();
    if (!email || !email.length) {
      return false;
    } else if (email.indexOf("@") == -1) {
      return false;
    }
    return true;
  }

  // Submit the form with an ajax/jsonp request.
  // Based on http://stackoverflow.com/a/15120409/215821
  function submitSubscribeForm($form, $resultElement) {
    $.ajax({
      type: "GET",
      url: $form.attr("action"),
      data: $form.serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",
      error: function(error){
        // According to jquery docs, this is never called for cross-domain JSONP requests
      },
      success: function(data){
        if (data.result != "success") {
          var message = data.msg || "Sorry. Unable to subscribe. Please try again.";
          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            message = "You're already subscribed. Thank you.";
          }
          $resultElement.html(message);
        } else {
          $resultElement.html("Thank you! You must confirm the subscription in your inbox.");
        }
      }
    });
  }
}

theme.getParameterByName = function(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/* ----------------------------
Customer ACTIONS
---------------------------- */
theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm, .account-login--title').toggleClass('hide');
    $('#create_customer, .account-register--title, .account-form-links').toggleClass('hide');
  }

  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/* ----------------------------
CART ACTIONS
---------------------------- */

theme.cartPage = function(){
  var timer;

  


  
  $('body').on('click', 'button[name="checkout"]', function(){
    var inputName = '';
    $('.cart-form input:hidden').each(function() {
      inputName = $(this).attr('name');
      if( inputName == 'updates[]' ) {
         $(this).val(1);
      }
    });
  });
};

// theme.addToCartflip = function($addToCartBtn){
//   var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to bag";

//   // Make a copy of the add to cart button should we flip it
//   $addToCartBtn
//     .clone(true)
//     .prop('disabled', false)
//     .removeClass('disabled')
//     .addClass('btn--unflipped')
//     .find('span')
//     .text(addToCartText)
//     .end()
//     .hide()
//     .insertAfter($addToCartBtn);

//   $addToCartBtn
//     .unbind('click')
//     .removeClass('disabled')
//     .find('span')
//     .text("View cart")
//     .end()
//     .bind('click', function(e) {
//       e.preventDefault();
//       //window.location.href = '/cart';
//       window.open('/cart','_top');
//     })
//     .prop('disabled', false)
//     .addClass('btn--flipped')
//     // .after('<span class="continue-shopping"> <a class="btn--secondary" href="/collections/all">Continue Shopping</a></span>');

//   //$('.continue-shopping a').bind('click', theme.backButton);

//   // Unflip button if another variant is selected
//   $('.dummy-select').bind('click', function() {
//     $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
//     $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
//   });
// };

// var $inlineCart = $('[data-inline-cart]');
// var $cartItemCount = $('[data-cart-item-count]');


// $(document).on('cart.requestComplete', function(event, cart) {
//     $.get('/cart?view=contents', function (response) {
//     $inlineCart.html(response);
//     $cartItemCount.text(cart.item_count);
//     console.log(cart.item_count);
//   });
// });

// theme.updateInlineCart = function(callback) {
//   var cart = CartJS.cart;
//   $.get('/cart?view=contents', function (response) {
//     $inlineCart.html(response);
//     $cartItemCount.text(cart.item_count);
//     console.log(cart.item_count);
//   });
//   if (typeof callback === 'function') {
//     callback();
//   }
// };

// theme.showInlineCart = function() {
//   console.log('ding');
//   $inlineCart.addClass('is-active');
// };

// theme.addToCartflip = function($addToCartBtn){
//   var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to bag";

//   // Make a copy of the add to cart button should we flip it
//   $addToCartBtn
//     .clone(true)
//     .prop('disabled', false)
//     .removeClass('disabled')
//     .addClass('btn--unflipped')
//     .find('span')
//     .text(addToCartText)
//     .end()
//     .hide()
//     .insertAfter($addToCartBtn);

//   $addToCartBtn
//     .unbind('click')
//     .removeClass('disabled')
//     .find('span')
//     .text("View cart")
//     .end()
//     .bind('click', function(e) {
//       e.preventDefault();
//       //window.location.href = '/cart';
//       window.open('/cart','_top');
//     })
//     .prop('disabled', false)
//     .addClass('btn--flipped')
//     // .after('<span class="continue-shopping"> <a class="btn--secondary" href="/collections/all">Continue Shopping</a></span>');

//   //$('.continue-shopping a').bind('click', theme.backButton);

//   // Unflip button if another variant is selected
//   $('.dummy-select').bind('click', function() {
//     $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
//     $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
//   });
// };

theme.enableAjax = function(){
  theme.cache.$addToCartBtn.bind('click', function(e) {
    e.preventDefault();
    // $('.note.errors').remove();

    // var $addToCartBtn = $(this),
    //     $addToCartForm = $(this).closest('form'),
    //     $addToCartBtnText = $(this).find('span');

    // if ($addToCartForm.length) {
    //   $addToCartBtn
    //     .attr('data-add-to-cart', $addToCartBtnText.text())
    //     .prop('disabled', true)
    //     .addClass('disabled')
    //     .addClass('btn--loading');
    //   $.ajax({
    //     url: '/cart/add.js',
    //     dataType: 'json',
    //     type: 'post',
    //     data: $addToCartForm.serialize(),
    //     success: function(lineItem) {
    //       $addToCartBtn.removeClass('btn--loading');
    //       theme.addToCartflip($addToCartBtn);

    //       if($('#quickshop').length) {
    //         var jsonstring  = JSON.stringify({ "action" : 'updateCart'});
    //         window.parent.postMessage(jsonstring, '*');
    //       }

    //       $.getJSON('/cart.js', function(cart) {
    //         $('#flyout-count').text(cart.item_count);
    //       });
    //       $.fancybox.close();
        
    //     },
    //     error: function(XMLHttpRequest, textStatus) {
    //       var data = eval('(' + XMLHttpRequest.responseText + ')');
    //       var response = data.description;
    //       var status = XMLHttpRequest.status;
    //       $addToCartBtn.removeClass('btn--loading');
    //       if (status === 422 && $('#productSelect option').length === 1) {
    //         $addToCartBtnText.text("Sold out");

    //       }
    //       else {
    //         $addToCartBtn.prop('disabled', false).removeClass('disabled');
    //         $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
    //       }
    //       $addToCartBtn.after('<p class="note errors">' + response + '</p>');
    //     }
    //   });
    // }
  });
};

// theme.addToCart = function() {

//   var cart = CartJS.cart;

//   $(document).on('click', '[data-add-to-cart]', function(event) {
//     event.preventDefault();
    
//     var $this = $(event.currentTarget);
//     var $addToCartForm = $this.closest('form');
//     var $addToCartBtnText = $this.find('span');
//     var variantId = $this.attr('data-variant-id') || false;
//     var qty = $('[qty-input]').val() || 1;

//     if (variantId) {
//       console.log(variantId);
     
//       CartJS.addItem(variantId, qty, {
//         "success": function(data, textStatus, jqXHR) {
//           theme.updateInlineCart(theme.showInlineCart);
//         },
//         "error": function(jqXHR, textStatus, errorThrown) {
//           alert('Error');
//           console.log(variantId);
//           console.log(jqXHR);
//           console.log(textStatus);
//           console.log(errorThrown);
//         }
//       });
//     }
//   });
// };

theme.initCartFlyout = function() {
  // theme.buildCartFlyout(false);

  // $(theme.cache.$cartTrigger).find('img').unwrap();

  // theme.cache.$cartTrigger.on({
  //  click: function(){
  //    theme.toggleCartFlyout();
  //  }
  // });

  // theme.cache.$w.on('resize', function(){
  //  theme.resizeCartFlyout();
  // });

  // theme.cache.$body.on('click', function(e){
  //  if (theme.cache.$cartFlyout.is(":visible")) {
  //    if (!$(e.target).closest(theme.cache.$cartFlyout).length && !$(e.target).closest(theme.cache.$cartTrigger).length) {
  //      theme.cache.$cartTrigger.click();
  //    }
  //  }
  // });

  // Remove Item From Cart
  // theme.cache.$cartFlyout.on('click', '.remove', function(){
  //  var productId = $(this).attr('data-id');
   
 //    CartJS.updateItemById(productId, 0, {}, {
 //      "success": (data, textStatus, jqXHR) => {
 //        theme.buildCartFlyout();
 //      },
 //      "error": (jqXHR, textStatus, errorThrown) => {
 //        ShopifyAPI.onError(XMLHttpRequest, textStatus);
 //      }
 //    });
  //  // theme.removeFromCart(productId);
  // });
}

// theme.removeFromCart = function(id){
//   var params = {
//     type: 'POST',
//     url: '/cart/change.js',
//     data: 'quantity=' + 0 + '&id=' + id,
//     dataType: 'json',
//     success: function(cart) {
//       theme.buildCartFlyout();
//     },
//     error: function(XMLHttpRequest, textStatus) {
//       ShopifyAPI.onError(XMLHttpRequest, textStatus);
//     }
//   };
//   $.ajax(params);
// }

theme.buildCartFlyout = function(show_flyout) {
  $.getJSON('/cart.js', function(cart) {
    cart.items == 0 ? theme.cache.$cartFlyout.addClass('empty') : theme.cache.$cartFlyout.removeClass('empty');

    // $('#flyout-count').text(cart.item_count);

    // show cart flyout
    var source = $("#cart-template").html(),
        template = Handlebars.compile(source),
        items = [],
        total = 0,
        total_qty = 0,
        img_small;
    $.each(cart.items, function(i,o){
      img_small = o.image ? o.image.replace(/^(.+)(\..+)$/, '$1_medium$2') : '';
      var shopify_price = Shopify.formatMoney(o.price);
      var new_price = shopify_price.replace('.00','');
      items.push({
        id: o.id,
        vendor: o.vendor,
        title: o.title,
        url: o.url,
        qty: o.quantity,
        price: new_price,
        image: img_small
      });
      // set total quantity of cart items
      total_qty += o.quantity;

      // set total price of all cart items
      total = total + o.line_price;
    });

    // $('.summary span', theme.cache.$cartFlyout).html( Shopify.formatMoney( cart.total_price ) );
    // $('.products', theme.cache.$cartFlyout).html( template({items:items}) );

    // if (show_flyout) {
    //  theme.toggleCartFlyout();
    //  var timer = setTimeout(function(){
    //    theme.toggleCartFlyout();
    //  }, 5000);
    //  theme.cache.$cartFlyout.on('mouseenter', function(){
    //    clearTimeout(timer);
    //  });
    // }
  });
}

// theme.resizeCartFlyout = function() {
//  $('.products', theme.cache.$cartFlyout).css({
//    height: (theme.cache.$w.outerHeight() - theme.cache.$header.outerHeight() - $('.summary').outerHeight())
//  });
// }

theme.toggleCartFlyout = function() {
  // theme.cache.$cartFlyout.toggle();
  // theme.cache.$cartTrigger.toggleClass('active');
  // theme.resizeCartFlyout();

  theme.cache.$searchTrigger.removeClass('active');
  theme.cache.$searchForm.removeClass('show');
}

theme.resetHeader = function() {
  $('#nav-tools li').removeClass('active');
  // theme.cart.$cartFlyout.hide();
  theme.cart.$searchForm.hide();
}

theme.full_messages_from_errors = function(errors){
  var fullMessages = [];
  $.each(errors, function(attribute, messages) {
    $.each(messages, function(index, message) {
      fullMessages.push(attribute + ' ' + message);
    });
  });
  return fullMessages;
};

theme.faq = function(){
  var $trigger =  $('.trigger', '.drawer');
  $trigger.click(function(){
    $(this).parents('.drawer').toggleClass('open');
  })
}

theme.tenstep = function(){
  var $trigger = $('.step-thumb');

  $trigger.click(function(){
    var $me = $(this),
        section = $me.attr('data-section'),
        $section = $('#'+section),
        distance = $section.offset().top - $('#header-container').outerHeight() - 77;

    $('html, body').animate({
      scrollTop: distance
    });

  });
}

theme.hpTenStep = function(){
  var $trigger = $('.step-trigger');

  $trigger.click(function(){
    var $me = $(this),
        section = $me.attr('data-section'),
        $section = $('#'+section);

    $me.addClass('active').siblings().removeClass('active');
    $section.addClass('active').siblings().removeClass('active');

  });
}

theme.collection = function(){
  var $sizeToggle = $('#toggle-column-size div'),
      $grid = $('.collection-grid');

  $sizeToggle.click(function(){
    var $me = $(this);

    $me.addClass('active').siblings().removeClass('active');
    if($me.hasClass('four-column')){
      $grid.removeClass('large-grid');
    } else {
      $grid.addClass('large-grid');
    }
  });

  var $filtersTrig = $('#filters-trigger'),
      $forms = $('.form-wrap');

  $filtersTrig.click(function(){
    $forms.stop().slideToggle(function(){
      $forms.css('overflow', 'visible !important');
    });
  });
}

theme.dummySelect = function(){

  $selectWrap = $('.selector-wrapper');

  $selectWrap.each(function(){

    var $me = $(this),
        $label = $me.find('label'),
        $select = $me.find('select'),
        $selectedOption = $me.find('option:selected'),
        $options = $select.find('option'),
        $dummy = $('<ul class="dummy-select"></ul>'),
        selectionText = $label.length > 0 ? $label.text() : $selectedOption.text(),
        $selection = $('<div class="selection">'+selectionText+'</div>');


    $options.each(function(i, el){
      $el = $(el);
      $dummy.append('<li data-val="'+$el.attr('value')+'" val="'+$el.attr('value')+'">'+$el.text()+'</li>');
    });
    $me.prepend($dummy);
    $me.prepend($selection);
    $label.add($select).hide();



    $dummy.find('li').click(function(){
      var value = $(this).attr('val'),
          text =  $(this).text();
      $selection.text(text).removeClass('show');
      $dummy.stop().slideUp(250);
      $select.val(value).trigger('change');

    });

    $selection.click(function(){
      $me = $(this);
      $me.toggleClass('show');
      $dummy.stop().slideToggle(250);
    });

  });
};

theme.jqueryUI = function(){
  if ($('.date-picker').length) {
    $( ".date-picker" ).datepicker();
  }
}

theme.filterBlog = function(){

  /// Simple function to expand/contract a div
  $(document).on('click', 'a[data-toggle-target]', function(e){
      var $target = $($(this).data('toggle-target'));
      $(this).find('.state').html( $target.is(':visible') ? '+' : '-' );
      $target.slideToggle(200);
      e.preventDefault();
  });

  //Already visible? Set state
  $('a[data-toggle-target]').each(function(){
      var $target = $($(this).data('toggle-target'));
      $(this).find('.state').html( $target.is(':visible') ? '-' : '+' );
  });

}

theme.skinQuiz = function(){
  var $progress = $('#progress-bar'),
      $steps = 0,
      active_step = 1,
      data = {};

  function init() {
    $steps = $('.step', theme.cache.$quiz);
    $('#quiz-intro').addClass('active');

    $('.answer', theme.cache.$quiz).click( setAnswer );
    $('.next', theme.cache.$quiz).click( next );
    $('#quiz-email').keyup( setEmail );
  }

  function getActiveStep() {
    return $steps.eq(active_step);
  }

  function setActiveStep(){
    $steps.removeClass('active').eq(active_step).addClass('active');
    $progress.css('width', ((active_step+1)/$steps.length)*100 + '%');
    theme.cache.$w.scrollTop(0);
  }

  function setEmail() {
    var $me = $(this);
    $me.prev('.email').attr('data-value', $me.val()).addClass('selected');
    data['EMAIL'] = $me.val();
  }

  function next(){
    var $me = $(this),
        $active_step = getActiveStep();

    if ( $(this).closest('#quiz-intro').length ) {
      setActiveStep();
    } else if ($active_step.find('.question').length === $active_step.find('.selected').length) {
      active_step++;
      $me.hasClass('finale') ? finishQuiz() : setActiveStep();
    }
  }

  function setAnswer(){
    var $me = $(this),
        $question = $me.closest('.question'),
        field, value;

    // set data props for Mailchimp
    field = $question.attr('data-question');
    value = $me.attr('data-value');
    data[field] = value;

    // set new answer to active
    $me.siblings().removeClass('selected')
       .end().addClass('selected');
  }

  function finishQuiz() {
    Sailthru.integration("userSignUp", {
      "email": data["EMAIL"],
      "lists": { "Subscribed 5718": 1 },
      "vars": {
        "Gender": data["MERGE5"],
        "Age Group": data["MERGE15"],
        "Routine": data["MERGE27"],
        "Skin Type": data["MERGE7"],
        "Skin Concern": data["MERGE26"]
      },
      "onSuccess": function () {
        var msg = 'Thank you for subscribing!';
        msg = encodeURIComponent(msg);
        sendTo(msg);
      },
      "onError": function() {
        var msg = 'Oops! Looks like you\'re already subscribed to our newsletter.';
        msg = encodeURIComponent(msg);
        sendTo(msg);
      }
    });
  }

  function sendTo(msg) {
    var collection_url = 'sq-' +data['MERGE7'].toLowerCase()+ '-' + data['MERGE26'].toLowerCase();
    window.location.href = "/collections/" + collection_url + '?sq-message=' + msg;
  }

  init();
}

theme.skinQuizResults = function(){
  var query = theme.getParameterByName('sq-message');

  query && theme.cache.$quiz.prepend('<p class="message">' + query + '</p>');

  $('.rte h4').each(function(i,el){
    $(el).nextUntil('h3', 'p').andSelf().wrapAll('<div class="answer"></div>');
  });
}

// Initialize theme's JS on docready
$(theme.init);
